import { defineMessages } from 'react-intl';

export default defineMessages({
  loading: {
    id: 'neptune.Table.loading',
    defaultMessage: 'Table data is loading',
  },
  loaded: {
    id: 'neptune.Table.loaded',
    defaultMessage: 'Table data has loaded',
  },
  emptyData: {
    id: 'neptune.Table.emptyData',
    defaultMessage: 'No results found',
  },
  refreshPage: {
    id: 'neptune.Table.refreshPage',
    defaultMessage: 'Refresh page',
  },
  actionHeader: {
    id: 'neptune.Table.actionHeader',
    defaultMessage: 'Action',
  },
});
